import { useEffect } from 'react';
import { usePostCancelSchedule } from '../usePostCancelSchedule/usePostCancelSchedule';
export function useCancelSchedule(onClose, onSuccess, onError) {
    const { loading, error, success, postCancelSchedule } = usePostCancelSchedule();
    useEffect(() => {
        if (success) {
            onClose();
            onSuccess();
        }
    }, [success, onClose, onSuccess]);
    useEffect(() => {
        if (error) {
            onClose();
            onError();
        }
    }, [error, onClose]);
    function cancelSchedule(id) {
        postCancelSchedule(id);
    }
    function close() {
        if (!loading) {
            onClose();
        }
    }
    return {
        loading,
        cancelSchedule,
        close,
    };
}
